import { noop } from '../../utils';
export var defaultMangerContext = {
  play: noop,
  unregister: noop
};